"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokenPaymentProfileException = void 0;
const http_exception_1 = require("../http.exception");
class BrokenPaymentProfileException extends http_exception_1.HttpException {
    constructor(reason) {
        super(501, `Broken payment profile: ${reason}`);
    }
}
exports.BrokenPaymentProfileException = BrokenPaymentProfileException;
//# sourceMappingURL=brokenPaymentProfile.exception.js.map